
export const lbbConfig = (cId) => {

    Fancybox.defaults.mainClass = 'myCustomClass';

    Fancybox.Plugins.Toolbar.defaults.items.zoomIn = {
        type: "button",
        class: "fancybox__button--zoomIn",
        label: "Zoom in",
        html: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z"/><path d="M10.5 7v3.5m0 0V14m0-3.5H14m-3.5 0H7"/></svg>',
        click: event => {
            event.preventDefault();

            const panzoom = this.fancybox.getSlide().Panzoom;

            if (panzoom) {
                panzoom.zoomIn();
            }
        }
    };

    Fancybox.Plugins.Toolbar.defaults.items.zoomOut = {
        type: "button",
        class: "fancybox__button--zoomOut",
        label: "Zoom Out",
        html: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z"/><path d="M13 10.5H8"/></svg>',
        click: (event) => {
            event.preventDefault();

            const panzoom = this.fancybox.getSlide().Panzoom;

            if (panzoom) {
                panzoom.zoomOut();
            }
        }
    };

    const preventPopupClose = () => {
        document.querySelectorAll('.fancybox__caption')?.forEach(item => {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                if (e.target.href) {
                    window.open(e.target.href, '_blank');
                }
            })
        })
    }


    Fancybox.bind(`[data-fancybox='gallery-${cId}']`, {
        on: { "done": preventPopupClose },
        defaults: { baseClass: "mycustomClass" },
        Toolbar: {
            display: [
                "slideshow",
                "counter",
                // "zoomIn",
                // "zoomOut",
                // "fullscreen",
                // "thumbs",
                "close",
            ],
        },
        Thumbs: {
            autoStart: true,
        }

    });

    Fancybox.bind(`[data-fancybox='audio-gallery-${cId}']`, {
        on: { "done": preventPopupClose },
        backdropClick: false,
        baseClass: 'myCustomClass',
        Toolbar: {
            display: [
                "slideshow",
                "counter",
                // "zoomIn",
                // "zoomOut",
                // "fullscreen",
                // "thumbs",
                "close",
            ],
        },
        Thumbs: {
            autoStart: true,
        }
    });

    Fancybox.bind(`[data-fancybox='video-gallery-${cId}']`, {
        on: { "done": preventPopupClose },
        Toolbar: {

            display: [
                "slideshow",
                "counter",
                // "zoomIn",
                // "zoomOut",
                // "fullscreen",
                // "thumbs",
                "close",
            ],
        },
        Thumbs: {
            autoStart: true,
        },
        baseClass: 'myCustomClass',
    });

    Fancybox.bind(`[data-fancybox='allDataGallery-${cId}']`, {
        defaults: { baseClass: "mycustomClass" },
        on: { "done": preventPopupClose },
        Toolbar: {
            display: [
                "slideshow",
                "counter",
                // "zoomIn",
                // "zoomOut",
                // "fullscreen",
                // "thumbs",
                "close",
            ],
        },
        Thumbs: {
            autoStart: true,
        }
    });
}
